import React from "react";
import { Box, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import BaseButton from "../Common/Buttons/BaseButton";
import SearchBar from "../Common/Search/SearchBar";

const DncHeader = ({
  setAddContactModal,
  setAddExcelModal,
  setShowDeletePopup,
  selectedIds,
  searchText,
  setSearchText,
}) => {
  return (
    <>
      <Box className="flex-between my-2">
        <Typography className="font-20-grey">DNC List</Typography>
        <Box className="flex-align-center" gap={1}>
          <SearchBar
            searchText={searchText}
            handleChange={(e) => {
              e.persist();
              setSearchText(e.target.value.trim());
            }}
          />
          <BaseButton
            title="Delete Contacts"
            variant="contained"
            handleClick={() => setShowDeletePopup(true)}
            startIcon={<DeleteOutlineIcon fontSize="small" />}
            disabled={selectedIds?.length < 1}
          />
          <BaseButton
            title="Add Contacts"
            variant="contained"
            handleClick={() => setAddContactModal(true)}
            startIcon={<AddIcon fontSize="small" />}
          />
          <BaseButton
            title="Upload"
            variant="contained"
            handleClick={() => setAddExcelModal(true)}
            startIcon={<UploadFileIcon fontSize="small" />}
          />
        </Box>
      </Box>
    </>
  );
};

export default DncHeader;
